import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { ParentDashboard } from "@/features/parent-dashboard";
import { StudentDashboard } from "@/features/student-dashboard";
import { SchoolAdminDashboard } from "@/features/school-admin-dashboard";
import { MerchantDashboard } from "@/features/merchant-dashboard";
import { SuperadminDashboard } from "@/features/superadmin-dashboard";
import { Sparkles } from "lucide-react";

export function AppPage() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl text-white" style={{ background: "#7B1416" }}>
          <Sparkles className="h-5 w-5" />
        </div>
        <h1 className="font-display text-2xl">Sign in to view your dashboard</h1>
        <p className="max-w-sm text-muted-foreground">
          You need an account to access the dashboard. Choose your portal on the sign-in page.
        </p>
        <Button asChild className="text-white hover:opacity-90" style={{ background: "#7B1416" }}>
          <a href="/auth">Sign in</a>
        </Button>
      </div>
    );
  }

  const role = profile?.role ?? "parent";

  switch (role) {
    case "student":
      return <StudentDashboard />;
    case "school_admin":
      return <SchoolAdminDashboard />;
    case "merchant":
      return <MerchantDashboard />;
    case "superadmin":
      return <SuperadminDashboard />;
    default:
      return <ParentDashboard />;
  }
}
